import styled from 'styled-components'

export const Container = styled.footer`
  padding: 2.8rem 0;
  margin-top: 8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--border);
  color: var(--muted);
  gap: 1.4rem;

  .logo {
    font-size: 1.6rem;
    color: var(--text);
    font-weight: 700;
    letter-spacing: 0.04rem;
  }

  p {
    letter-spacing: 0.05rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--muted);

    img {
      width: 2.4rem;
      animation: spinning 6s infinite linear;
    }
  }

  .social-media {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;

    a {
      width: 3.8rem;
      height: 3.8rem;
      display: grid;
      place-items: center;
      border-radius: 50%;
      border: 1px solid var(--border);
      background: var(--pill-bg);
      transition: transform 0.2s ease, background 0.2s ease;

      &:hover {
        transform: translateY(-2px);
        background: var(--gradient);
      }

      img {
        width: 2rem;
      }
    }
  }

  @keyframes spinning {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
  }
`
